"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateData = exports.removeData = exports.getData = exports.addData = void 0;
/* eslint-disable prefer-promise-reject-errors */
/* eslint-disable func-names */
var handleException = function handleException(err, reject) {
  switch (err.name) {
    case 'InvalidStateError':
      return reject({
        status: 500,
        exception: err.name,
        message: 'The close() method has previously been called on this IDBDatabase instance.'
      });
    case 'NotFoundError':
      return reject({
        status: 500,
        exception: err.name,
        message: 'An object store specified in the storeNames parameter has been deleted or removed.'
      });
    case 'TypeError':
      return reject({
        status: 500,
        exception: err.name,
        message: 'The value for the mode parameter is invalid.'
      });
    case 'InvalidAccessError':
      return reject({
        status: 500,
        exception: err.name,
        message: 'The function was called with an empty list of store names.'
      });
    default:
      break;
  }
};
var getData = exports.getData = function getData(db, store, key) {
  return new Promise(function (resolve, reject) {
    var transaction = null;
    try {
      if (!db) throw new Error('InvalidStateError');
      transaction = db.transaction([store], 'readonly');
    } catch (err) {
      return handleException(err, reject);
    }
    var objectStore = transaction.objectStore(store);
    var request = objectStore.get(key);
    request.onsuccess = function () {
      if (request.result) resolve({
        status: 200,
        data: request.result
      });else reject({
        status: 404
      });
    };
    request.onerror = function () {
      reject({
        status: 500,
        rawMessage: request.error
      });
    };
  });
};
var addData = exports.addData = function addData(db, store, key, value) {
  return new Promise(function (resolve, reject) {
    var transaction = null;
    try {
      if (!db) throw new Error('InvalidStateError');
      transaction = db.transaction([store], 'readwrite');
    } catch (err) {
      return handleException(err, reject);
    }
    var objectStore = transaction.objectStore(store);
    var request = objectStore.add(value, key);
    request.onsuccess = function () {
      resolve({
        status: 200,
        data: request.result
      });
    };
    request.onerror = function () {
      reject({
        status: 400,
        message: 'Entry already exists',
        rawMessage: request.error
      });
    };
  });
};
var updateData = exports.updateData = function updateData(db, store, key, value) {
  return new Promise(function (resolve, reject) {
    var transaction = null;
    try {
      if (!db) throw new Error('InvalidStateError');
      transaction = db.transaction([store], 'readwrite');
    } catch (err) {
      return handleException(err, reject);
    }
    var objectStore = transaction.objectStore(store);
    var request = objectStore.put(value, key);
    request.onsuccess = function () {
      resolve({
        status: 200,
        data: request.result
      });
    };
    request.onerror = function () {
      reject({
        status: 400,
        message: 'Entry already exists',
        rawMessage: request.error
      });
    };
  });
};
var removeData = exports.removeData = function removeData(db, store, key) {
  return new Promise(function (resolve, reject) {
    var transaction = null;
    try {
      if (!db) throw new Error('InvalidStateError');
      transaction = db.transaction([store], 'readwrite');
    } catch (err) {
      return handleException(err, reject);
    }
    var objectStore = transaction.objectStore(store);
    var request = objectStore["delete"](key);
    request.onsuccess = function () {
      resolve({
        status: 200,
        data: request.result
      });
    };
    request.onerror = function () {
      reject({
        status: 500,
        rawMessage: request.error
      });
    };
  });
};